import React from 'react';

const TableEl = ({ columns, rows }) => (
  <div className="json-table-scroll">
    <table className="w-full border-collapse" style={{ borderColor: 'var(--border)' }}>
      <thead>
        <tr className="table-header">
          {columns.map((header, i) => (
            <th
              key={i}
              className="px-3 py-2 text-left"
              style={{ border: '1px solid var(--border)' }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex} className="table-row">
            {Array.isArray(row) ? (
              row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-3 py-2"
                  style={{ border: '1px solid var(--border)', color: 'var(--text-secondary)' }}
                >
                  {typeof cell === 'object' ? JSON.stringify(cell) : cell}
                </td>
              ))
            ) : (
              <td
                className="px-3 py-2"
                style={{ border: '1px solid var(--border)', color: 'var(--text-secondary)' }}
              >
                {typeof row === 'object' ? JSON.stringify(row) : row}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const JsonTable = ({ tableData, title }) => {
  if (!tableData) return null;

  let tables = [];
  if (Array.isArray(tableData)) {
    tables = tableData;
  } else if (tableData.tables && Array.isArray(tableData.tables)) {
    tables = tableData.tables;
  } else {
    tables = [tableData];
  }

  if (tables.length === 0) return null;

  return (
    <div className="card">
      {title && <h2 className="section-header">{title}</h2>}
      <div className="space-y-6">
        {tables.map((table, tableIndex) => {
          const tableTitle = table.title || table.name || table.subtitle;
          const tableDescription = table.description;
          const notes = table.notes || table.footnote || [];
          const footnotes = table.footnotes || {};

          return (
            <div key={tableIndex} className="space-y-3">
              {tableTitle && (
                <h3 className="section-title" style={{ fontSize: '1rem' }}>{tableTitle}</h3>
              )}
              {tableDescription && (
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem' }}>
                  {tableDescription}
                </p>
              )}

              {table.sections && Array.isArray(table.sections) ? (
                <div className="space-y-4">
                  {table.sections.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="space-y-2">
                      {section.subtitle && (
                        <h4 style={{ fontFamily: 'Cinzel, Georgia, serif', fontSize: '0.85rem', color: 'var(--text-secondary)', letterSpacing: '0.04em' }}>
                          {section.subtitle}
                        </h4>
                      )}
                      {section.columns && section.rows && (
                        <TableEl columns={section.columns} rows={section.rows} />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                table.columns && table.rows && (
                  <TableEl columns={table.columns} rows={table.rows} />
                )
              )}

              {notes && notes.length > 0 && (
                <div className="space-y-1" style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                  {Array.isArray(notes)
                    ? notes.map((note, i) => <p key={i}>{note}</p>)
                    : <p>{notes}</p>}
                </div>
              )}

              {footnotes && Object.keys(footnotes).length > 0 && (
                <div className="space-y-1" style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                  {Object.entries(footnotes).map(([symbol, text]) => (
                    <p key={symbol}><strong>{symbol}</strong> {text}</p>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JsonTable;
